<template>
	<v-app>
		<v-navigation-drawer style="overflow-y: hidden" permanent mini-variant-width="50" app color="dark" dark v-model="drawer" :mini-variant="miniVariant" :expand-on-hover="miniVariant">
			<v-list>
				<v-list-item>
					<v-switch @change="keepDrawerOpened" v-model="isNavDrawerExpanded" style="transform:scale(0.8);"></v-switch>
					<v-list-item-content>
						<v-list-item-title>Expanded Dashboard </v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-for="item in items" :key="item.title" :to="item.link" @click="item.action()">
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<div>
			<router-view />
		</div>
	</v-app>
</template>

<script>
import { CommonService, ParseAuthService } from "../services";
export default {
	name: "Maintainer",
	methods: {
		empty(){},
		handleSignOut() {
			CommonService.showLoading(true);
			ParseAuthService.logOut()
				.then(() => {
					CommonService.showLoading(false);
					this.$router
						.replace({
							name: "Login",
						})
						.catch((ex) => {
							CommonService.showLoading(false);
							console.log(ex);
						});
				})
				.catch((ex) => console.log(ex));
		},
		keepDrawerOpened() {
			this.miniVariant = !this.isNavDrawerExpanded;
			this.$store.commit('expandNav',this.isNavDrawerExpanded);
		},
	},
	data() {
		return {
			drawer: true,
			isNavDrawerExpanded: this.$store.state.expandedNav,
			miniVariant: !this.$store.state.expandedNav,
			items: [
				{ title: "Dashboard", icon: "mdi-view-dashboard",link: 'dashboard',action:this.empty },
				{ title: "File", icon: "mdi-file", link:'file', action:this.empty },
				{ title: "Artist", icon: "mdi-face", link:'artist', action:this.empty },
				{ title: "Album", icon: "mdi-album", link:'album', action:this.empty },
				{ title: "Media", icon: "mdi-book", link:'media', action:this.empty },
				{ title: "Thumbnail", icon: "mdi-image", link:'thumbnail', action:this.empty },
				{ title: "CdLink Category", icon: "mdi-layers", link:'cdLinkCategory', action:this.empty },
				{ title: "CdLink", icon: "mdi-link", link:'cdLink', action:this.empty },
				{ title: "Song Type", icon: "mdi-view-list", link:'songType', action:this.empty },
				{ title: "Song", icon: "mdi-music", link:'song', action:this.empty },
				{ title: "Logout", icon: "mdi-logout", link:'', action: this.handleSignOut },
			],
		};
	},
};
</script>
